import { useMemo } from "react";
import { Column, useTable } from "react-table";
import {
  Badge,
  DefinitionList,
  DefinitionListItem,
  Link,
  MaskCnpj,
  MaskCpf,
} from "@funcional/react-ui";
import {
  IntlDateTime,
  IntlEnum,
  IntlMoney,
  IntlPercentage,
} from "@funcional/react-intl-ui";
import { IPreTransaction, ITransactionItem } from "@pbm/transactions/contracts";
import { ReactTable } from "@funcional/react-table-ui";

export function PreTransactionCard({
  transaction,
}: {
  transaction: IPreTransaction;
}) {
  const columns: Column<ITransactionItem>[] = useMemo(
    () =>
      [
        {
          Header: "Programa",
          accessor: "programCode",
          Cell: ({ value }) => (
            <Link to={`/pbm/programs/${value}`}>{value}</Link>
          ),
        },
        { Header: "EAN", accessor: "ean" },
        {
          Header: "Status",
          accessor: "status",
          Cell: ({ row, value }) => (
            <Badge color={value === "AUTHORIZED" ? "success" : "warning"}>
              {(row as any).original.statusCode}:&nbsp;
              <IntlEnum name="pre_transaction_item_status" value={value} />
            </Badge>
          ),
        },
        { Header: "Mensagem", accessor: "statusMessage" },
        { Header: "Qtd.", accessor: "quantity" },
        {
          Header: "% Desc.",
          accessor: "discountPercentage",
          Cell: ({ value }) => <IntlPercentage value={value} />,
        },
        {
          Header: "Valor Bruto",
          accessor: "grossValue",
          Cell: ({ value }) => <IntlMoney value={value} />,
        },
        {
          Header: "Valor Líquido",
          accessor: "netValue",
          Cell: ({ value }) => <IntlMoney value={value} />,
        },
      ] as Column<ITransactionItem>[],
    []
  );

  const tableInstance = useTable({ columns, data: transaction.items || [] });

  return (
    <>
      <DefinitionList>
        <DefinitionListItem label="Programa">
          {transaction.programCode}
        </DefinitionListItem>
        <DefinitionListItem label="CNPJ">
          <MaskCnpj value={transaction.storeCode} />
        </DefinitionListItem>
        <DefinitionListItem label="CPF">
          <Link to={`/pbm/beneficiaries/${transaction.beneficiary?.id}`}>
            <MaskCpf value={transaction.customerCode} />
          </Link>
        </DefinitionListItem>
        <DefinitionListItem label="Data">
          <IntlDateTime value={transaction.createdAt} />
        </DefinitionListItem>
        <DefinitionListItem label="№ Autorização">
          {transaction?.legacyIdentifiers?.authorizationId || "N/A"}
        </DefinitionListItem>
        <DefinitionListItem label="№ Sequencial">
          {transaction?.legacyIdentifiers?.sequenceId || "N/A"}
        </DefinitionListItem>
        <DefinitionListItem label="Origem">
          <span title={transaction.origin}>
            <IntlEnum name="authorization_origin" value={transaction.origin} />
          </span>
        </DefinitionListItem>
        <DefinitionListItem label="Tipo">
          <span title={transaction.type}>
            <IntlEnum name="pre_transaction_type" value={transaction.type} />
          </span>
        </DefinitionListItem>
        <DefinitionListItem label="Status">
          <Badge color={transaction.status === "VALID" ? "success" : "danger"}>
            <span title={transaction.status}>
              {transaction.statusCode}:&nbsp;
              <IntlEnum
                name="pre_transaction_status"
                value={transaction.status}
              />
            </span>
          </Badge>
        </DefinitionListItem>
        <DefinitionListItem label="Descrição">
          {transaction.statusMessage}
        </DefinitionListItem>
        <DefinitionListItem label="Valor Bruto">
          <IntlMoney value={transaction.grossValue} />
        </DefinitionListItem>
        <DefinitionListItem label="Valor Desconto">
          <IntlMoney value={transaction.discountValue} />
        </DefinitionListItem>
        <DefinitionListItem label="Valor Líquido">
          <IntlMoney value={transaction.netValue} />
        </DefinitionListItem>
      </DefinitionList>

      <ReactTable className="mt-8" tableInstance={tableInstance} />
    </>
  );
}
